import { Link } from 'react-router-dom';
import styles from './GettingStarted.module.css';

// The shortest path from a new account to a first verified lead list. Five concrete steps,
// each written as an action the reader can take right now.
const STEPS = [
  {
    n: '1',
    title: 'Create your account',
    body: 'Sign up with any email address. You do not need a work email or a credit card to start. Your trial gives you seven days and thirty verified leads to try the full workflow.',
  },
  {
    n: '2',
    title: 'Fill in your Seller Profile',
    body: 'Tell RepBuddy who you sell to and what you sell. This is the single biggest lever on result quality. Every hunt reads from this profile, so the more accurate it is, the better your matches.',
  },
  {
    n: '3',
    title: 'Run your first contact hunt',
    body: 'Open a new search and type what you want in plain English, for example "Find me 15 VPs of Operations at logistics companies in the Southeast." RepBuddy fills in anything you leave out from your profile.',
  },
  {
    n: '4',
    title: 'Review what comes back',
    body: 'Each contact arrives with a verified, deliverable email and confirmation that the person still works where the record says. Contacts that fail these checks never reach your list and are never charged.',
  },
  {
    n: '5',
    title: 'Export or draft outreach',
    body: 'Export the list to CSV for your CRM or sequencer, or ask RepBuddy to draft a personalized opener for any contact and revise it in the chat until it sounds like you.',
  },
];

export default function GettingStarted() {
  return (
    <section id="getting-started" className={styles.section}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>Quick start</span>
        <h2 className={styles.heading}>Getting started in five steps</h2>
        <p className={styles.lede}>
          If you only read one section, read this one. It takes you from a brand-new account
          to your first list of real, verified leads.
        </p>

        <ol className={styles.steps}>
          {STEPS.map((s) => (
            <li key={s.n} className={styles.step}>
              <span className={styles.num} aria-hidden="true">{s.n}</span>
              <div className={styles.stepBody}>
                <h3 className={styles.stepTitle}>{s.title}</h3>
                <p className={styles.stepText}>{s.body}</p>
              </div>
            </li>
          ))}
        </ol>

        <p className={styles.note}>
          New here? <Link className={styles.inlineLink} to="/register">Start your free trial</Link>{' '}
          and follow along as you read.
        </p>
      </div>
    </section>
  );
}
